import { Code } from '@workos-inc/design-system';
import type { PropDefinition } from 'src/components/props-table';
import { AccessTokenDescription, WidgetSessionScope } from './components';
export const scopes: WidgetSessionScope[] = ['widgets:users-table:manage'];
export const props: PropDefinition[] = [{
  name: 'authToken',
  typeSimple: 'AuthToken',
  type: 'string | (() => Promise<string>)',
  required: true,
  description: <AccessTokenDescription scopes={scopes} />
}, {
  name: 'currentSessionId',
  typeSimple: 'string',
  description: 'The current user’s session ID',
  required: <>
        When an async function is passed to the <Code>authToken</Code> prop,{' '}
        <Code>currentSessionId</Code> can be omitted as the claims will be
        validated internally.
      </>
}];